var map = {
	"./1.png": "MOsO",
	"./10.png": "/XLB",
	"./10en.png": "SVSE",
	"./11.png": "fdWz",
	"./11en.png": "dMzW",
	"./12.png": "p9DG",
	"./12en.png": "Tt7b",
	"./1en.png": "erzc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Wmw0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing ^\.\/1.*\.png$
// module id = Wmw0
// module chunks = 0